import React from 'react'
import { Container, FlexWrapper,} from '../../Components/Common';
import Footer from '../../Components/Footer/Footer';
import Navbar from '../../Components/Navbar/Navbar';
import TempeleteOne from '../../Components/Template/Templete1';
import { CardsContainer, HeroSectionWrapper, MainWrapper } from './styles';
import ScrollAnimation from "react-animate-on-scroll";
import CardOne from '../../Components/Cards/CardOne';
import StarImage from "../../Assets/star.png";

const Templete = () => {
    return (
      <>
        <Navbar />
        {/* hero section */}
        <MainWrapper>
          <ScrollAnimation animateIn="fadeIn" duration={1} delay={150}>
            <HeroSectionWrapper>
              <Container width={"95%"}>
                <TempeleteOne
                  heading1={"What Can Escribelo Help You Write"}
                  heading2={" Faster Today?"}
                  description={
                    "Discover 50+ writing skills Jarvis has learned from expert"
                  }
                  description2={" copywriters."}
                  ButtonTitle={"Apply to be a partner"}
                  styles={{ margin: "0px auto", padding: "0px" }}
                />

                <CardsContainer>
                  <FlexWrapper
                    wrap={"wrap"}
                    width={"100%"}
                    gap={"50px"}
                    justify={"space-around"}
                  >
                    {Array.from(Array(30).keys()).map((item, index) => (
                      <div
                        style={{
                          width: "30%",
                          minWidth: "200px",
                          maxWidth: "250px",
                        }}
                      >
                        <CardOne
                          title={"Content improver"}
                          title2={""}
                          description={
                            "Take a piece of content and rewrite it to make it more interesting, creative, and engaging."
                          }
                          imageSize={40}
                          imageUrl={StarImage}
                          key={index}
                        />
                      </div>
                    ))}
                  </FlexWrapper>
                </CardsContainer>
                <TempeleteOne
                  heading1={"Unlock All These Templates On The"}
                  heading2={" Starter Plan For Just $29/Mo."}
                  description={
                    "The starter plan is best for customers who want quick wins for short-form writing such as"
                  }
                  description2={
                    " advertisements, social media, and conversion copywriting."
                  }
                  ButtonTitle={"Get started"}
                  styles={{ margin: "40px auto 150px  auto", padding: "0px" }}
                />
              </Container>
            </HeroSectionWrapper>
          </ScrollAnimation>

          <Footer />
        </MainWrapper>
      </>
    );
}

export default Templete
